module.exports = __webpack_public_path__ + "img/outscale.97c433a9.svg";